const textTables = document.querySelectorAll('.text table');

const wrap = (toWrap, wrapper) => {
  wrapper = wrapper || document.createElement('div');
  wrapper.classList.add('table-wrapper');
  toWrap.parentNode.insertBefore(wrapper, toWrap);
  return wrapper.appendChild(toWrap);
};

if (textTables.length) {
  [].forEach.call(textTables, table => {
    wrap(table);
  })
}